import VideoPlayer from 'Components/VideoPlayer';
import { VideoPlayerPlaceholderSrcSet } from 'Components/VideoPlayer/VideoPlayerThumbnail';
import { IImageBaseViewModel } from 'Scripts/Types/Litium';
import { ISrcSetSize } from 'Types/shared';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

interface ProductVideoSlideProps {
    url: string;
    image: IImageBaseViewModel;
    srcSetSizes: ISrcSetSize;
}

const ProductVideoSlide = ({
    url,
    image,
    srcSetSizes,
}: ProductVideoSlideProps) => {
    const videoPlaceholderSizes: VideoPlayerPlaceholderSrcSet = Object.entries(
        srcSetSizes
    )
        .map(([key, value]) => {
            const sizeValue = value as ISrcSetSize['default'];
            return {
                breakpoint:
                    tailwindBreakpoints[
                        key as keyof typeof tailwindBreakpoints
                    ],
                width: sizeValue.width,
                height: sizeValue.height,
                src: image.src,
                altText: image.altText,
            };
        })
        .filter(x => x.breakpoint);

    return (
        <div className="h-full w-full overflow-hidden">
            <VideoPlayer
                autoPlay
                url={url}
                placeholderLarge={image}
                placeholderSmall={image}
                altDescription={image?.altText}
                placeholderAlt={image?.altText}
                videoPlaceholderSizes={videoPlaceholderSizes}
            />
        </div>
    );
};

export default ProductVideoSlide;
